module.exports = __webpack_public_path__ + "svg/roulette-timer.svg?e3e36a6ab930151bc207c0c1f0588d10";